// // // import React, { useState } from 'react';
// // // import { motion } from 'framer-motion';
// // // import './DignitaryAdmin.css';

// // // const API_URL =
// // //   process.env.REACT_APP_API_URL || 'http://localhost:3001';

// // // const initialForm = {
// // //   fullName: '',
// // //   email: '',
// // //   phone: '',
// // //   title: '',
// // //   organization: '',
// // // };

// // // export default function DignitaryAdmin() {
// // //   const [form, setForm] = useState(initialForm);
// // //   const [adminKey, setAdminKey] = useState('');
// // //   const [loading, setLoading] = useState(false);
// // //   const [error, setError] = useState('');
// // //   const [created, setCreated] = useState(null);
// // //   const [copied, setCopied] = useState(false);

// // //   const handleChange = (event) => {
// // //     const { name, value } = event.target;

// // //     setForm((current) => ({
// // //       ...current,
// // //       [name]: value,
// // //     }));

// // //     if (error) setError('');
// // //   };

// // //   const handleSubmit = async (event) => {
// // //     event.preventDefault();

// // //     if (!adminKey.trim()) {
// // //       setError('Enter your admin access key.');
// // //       return;
// // //     }

// // //     if (!form.fullName.trim()) {
// // //       setError('Dignitary full name is required.');
// // //       return;
// // //     }

// // //     setLoading(true);
// // //     setError('');
// // //     setCreated(null);
// // //     setCopied(false);

// // //     try {
// // //       const response = await fetch(
// // //         `${API_URL}/api/birthday/dignitary/create`,
// // //         {
// // //           method: 'POST',
// // //           headers: {
// // //             'Content-Type': 'application/json',
// // //             'x-admin-key': adminKey.trim(),
// // //           },
// // //           body: JSON.stringify({
// // //             fullName: form.fullName.trim(),
// // //             email: form.email.trim(),
// // //             phone: form.phone.trim(),
// // //             title: form.title.trim(),
// // //             organization: form.organization.trim(),
// // //           }),
// // //         }
// // //       );

// // //       const result = await response.json();

// // //       if (!response.ok || !result.success) {
// // //         throw new Error(
// // //           result.message ||
// // //             'Unable to create this dignitary invitation.'
// // //         );
// // //       }

// // //       setCreated(result.data);
// // //       setForm(initialForm);
// // //     } catch (err) {
// // //       setError(
// // //         err.message ||
// // //           'Unable to create this dignitary invitation.'
// // //       );
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const copyInvitationLink = async () => {
// // //     if (!created?.invitationLink) return;

// // //     try {
// // //       await navigator.clipboard.writeText(
// // //         created.invitationLink
// // //       );

// // //       setCopied(true);

// // //       setTimeout(() => {
// // //         setCopied(false);
// // //       }, 2000);
// // //     } catch {
// // //       setError(
// // //         'Could not copy automatically. Please copy the link manually.'
// // //       );
// // //     }
// // //   };

// // //   const createAnother = () => {
// // //     setCreated(null);
// // //     setCopied(false);
// // //     setError('');
// // //   };

// // //   return (
// // //     <div className="dignitary-admin-page">
// // //       <div className="dignitary-admin-glow dignitary-admin-glow--one" />
// // //       <div className="dignitary-admin-glow dignitary-admin-glow--two" />

// // //       <motion.main
// // //         className="dignitary-admin-card"
// // //         initial={{ opacity: 0, y: 24 }}
// // //         animate={{ opacity: 1, y: 0 }}
// // //         transition={{ duration: 0.45 }}
// // //       >
// // //         <div className="dignitary-admin-lock">
// // //           VIP
// // //         </div>

// // //         <span className="dignitary-admin-eyebrow">
// // //           Private 
// // //         </span>

// // //         <h1>
// // //           Create VIP Invitation
// // //         </h1>

// // //         <p className="dignitary-admin-intro">
// // //           Create a private invitation for a VIP
// // //           {/* The generated link should be shared directly with the
// // //           intended guest only. */}
// // //         </p>

// // //         {error && (
// // //           <div
// // //             className="dignitary-admin-alert"
// // //             role="alert"
// // //           >
// // //             {error}
// // //           </div>
// // //         )}

// // //         {created ? (
// // //           <motion.section
// // //             className="dignitary-created"
// // //             initial={{ opacity: 0, scale: 0.98 }}
// // //             animate={{ opacity: 1, scale: 1 }}
// // //           >
// // //             <div className="dignitary-created-check">
// // //               ✓
// // //             </div>

// // //             <span className="dignitary-created-label">
// // //               Invitation Created
// // //             </span>

// // //             <h2>
// // //               {created.fullName}
// // //             </h2>

// // //             {(created.title ||
// // //               created.organization) && (
// // //               <p>
// // //                 {[created.title, created.organization]
// // //                   .filter(Boolean)
// // //                   .join(' · ')}
// // //               </p>
// // //             )}

// // //             <div className="dignitary-access-box">
// // //               <span>ACCESS</span>

// // //               <strong>✓ Thanksgiving Service</strong>
// // //               <strong>✓ Reception / Banquet</strong>
// // //             </div>

// // //             <div className="dignitary-link-box">
// // //               <span>
// // //                 Private Invitation Link
// // //               </span>

// // //               <input
// // //                 type="text"
// // //                 value={created.invitationLink || ''}
// // //                 readOnly
// // //               />

// // //               <button
// // //                 type="button"
// // //                 onClick={copyInvitationLink}
// // //               >
// // //                 {copied
// // //                   ? 'Copied ✓'
// // //                   : 'Copy Invitation Link'}
// // //               </button>
// // //             </div>

// // //             <p className="dignitary-private-note">
// // //               This page is not listed on the public website.
// // //               Send the private link directly to the dignitary.
// // //             </p>

// // //             <button
// // //               type="button"
// // //               className="dignitary-secondary-button"
// // //               onClick={createAnother}
// // //             >
// // //               Create Another Invitation
// // //             </button>
// // //           </motion.section>
// // //         ) : (
// // //           <form
// // //             className="dignitary-admin-form"
// // //             onSubmit={handleSubmit}
// // //           >
// // //             <div className="dignitary-admin-field dignitary-admin-field--secret">
// // //               <label htmlFor="dignitary-admin-key">
// // //                 Admin Access Key
// // //               </label>

// // //               <input
// // //                 id="dignitary-admin-key"
// // //                 type="password"
// // //                 value={adminKey}
// // //                 onChange={(event) => {
// // //                   setAdminKey(event.target.value);

// // //                   if (error) setError('');
// // //                 }}
// // //                 placeholder="Enter your private admin key"
// // //                 autoComplete="off"
// // //                 required
// // //               />

// // //               <small>
// // //                 The key is used only for this request and is
// // //                 not stored in the browser.
// // //               </small>
// // //             </div>

// // //             <div className="dignitary-admin-divider">
// // //               <span />
// // //               <b>VIP DETAILS</b>
// // //               <span />
// // //             </div>

// // //             <div className="dignitary-admin-field">
// // //               <label htmlFor="dignitary-full-name">
// // //                 Full Name
// // //               </label>

// // //               <input
// // //                 id="dignitary-full-name"
// // //                 name="fullName"
// // //                 type="text"
// // //                 value={form.fullName}
// // //                 onChange={handleChange}
// // //                 placeholder="e.g. Esteemed Pastor Jane Doe"
// // //                 required
// // //               />
// // //             </div>

// // //             <div className="dignitary-admin-grid">
// // //               <div className="dignitary-admin-field">
// // //                 <label htmlFor="dignitary-title">
// // //                   Title
// // //                 </label>

// // //                 <input
// // //                   id="dignitary-title"
// // //                   name="title"
// // //                   type="text"
// // //                   value={form.title}
// // //                   onChange={handleChange}
// // //                   placeholder="e.g. Esteemed Pastor"
// // //                 />
// // //               </div>

// // //               <div className="dignitary-admin-field">
// // //                 <label htmlFor="dignitary-organization">
// // //                   Ministry/Zone
// // //                 </label>

// // //                 <input
// // //                   id="dignitary-organization"
// // //                   name="organization"
// // //                   type="text"
// // //                   value={form.organization}
// // //                   onChange={handleChange}
// // //                   placeholder="e.g. Loveworld"
// // //                 />
// // //               </div>
// // //             </div>

// // //             <div className="dignitary-admin-grid">
// // //               <div className="dignitary-admin-field">
// // //                 <label htmlFor="dignitary-email">
// // //                   Email
// // //                 </label>

// // //                 <input
// // //                   id="dignitary-email"
// // //                   name="email"
// // //                   type="email"
// // //                   value={form.email}
// // //                   onChange={handleChange}
// // //                   placeholder="Optional"
// // //                   autoComplete="email"
// // //                 />
// // //               </div>

// // //               <div className="dignitary-admin-field">
// // //                 <label htmlFor="dignitary-phone">
// // //                   Phone
// // //                 </label>

// // //                 <input
// // //                   id="dignitary-phone"
// // //                   name="phone"
// // //                   type="tel"
// // //                   value={form.phone}
// // //                   onChange={handleChange}
// // //                   placeholder="Optional"
// // //                   autoComplete="tel"
// // //                 />
// // //               </div>
// // //             </div>

// // //             <motion.button
// // //               type="submit"
// // //               className="dignitary-admin-submit"
// // //               disabled={loading}
// // //               whileHover={
// // //                 !loading ? { scale: 1.01 } : {}
// // //               }
// // //               whileTap={
// // //                 !loading ? { scale: 0.99 } : {}
// // //               }
// // //             >
// // //               {loading
// // //                 ? 'Creating Invitation…'
// // //                 : 'Create Private Invitation'}
// // //             </motion.button>
// // //           </form>
// // //         )}
// // //       </motion.main>
// // //     </div>
// // //   );
// // // }



// // import React, { useState } from 'react';
// // import { motion } from 'framer-motion';
// // import { useNavigate } from 'react-router-dom';
// // import './DignitaryAdmin.css';

// // const API_URL =
// //   process.env.REACT_APP_API_URL || 'https://lsdcnodejs-api.onrender.com';

// // const initialForm = {
// //   fullName: '',
// //   email: '',
// //   phone: '',
// //   title: '',
// //   organization: '',
// // };

// // const normalizeInvitationCode = (value = '') => {
// //   const raw = value.trim();

// //   if (!raw) return '';

// //   // Allows you to paste either:
// //   // VIP-xxxxxxxx
// //   // OR the complete invitation URL.
// //   try {
// //     if (
// //       raw.startsWith('http://') ||
// //       raw.startsWith('https://')
// //     ) {
// //       const url = new URL(raw);
// //       const parts = url.pathname
// //         .split('/')
// //         .filter(Boolean);

// //       const invitationIndex =
// //         parts.indexOf('invitation');

// //       if (
// //         invitationIndex !== -1 &&
// //         parts[invitationIndex + 1]
// //       ) {
// //         return decodeURIComponent(
// //           parts[invitationIndex + 1]
// //         );
// //       }

// //       return decodeURIComponent(
// //         parts[parts.length - 1] || ''
// //       );
// //     }
// //   } catch {
// //     // Fall through and treat the input as a raw code.
// //   }

// //   // Also handles someone pasting:
// //   // /invitation/VIP-xxxxx
// //   const inviteMarker = '/invitation/';

// //   if (raw.includes(inviteMarker)) {
// //     return decodeURIComponent(
// //       raw
// //         .split(inviteMarker)
// //         .pop()
// //         .split('?')[0]
// //         .split('#')[0]
// //         .replace(/\/+$/, '')
// //     );
// //   }

// //   return raw
// //     .split('?')[0]
// //     .split('#')[0]
// //     .replace(/\/+$/, '');
// // };

// // export default function DignitaryAdmin() {
// //   const navigate = useNavigate();

// //   const [form, setForm] = useState(initialForm);
// //   const [adminKey, setAdminKey] = useState('');

// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState('');

// //   const [created, setCreated] = useState(null);
// //   const [copied, setCopied] = useState(false);

// //   // Existing VIP invitation access
// //   const [invitationCode, setInvitationCode] =
// //     useState('');

// //   const [
// //     invitationLookupLoading,
// //     setInvitationLookupLoading,
// //   ] = useState(false);

// //   const [
// //     invitationLookupError,
// //     setInvitationLookupError,
// //   ] = useState('');

// //   const handleChange = (event) => {
// //     const { name, value } = event.target;

// //     setForm((current) => ({
// //       ...current,
// //       [name]: value,
// //     }));

// //     if (error) {
// //       setError('');
// //     }
// //   };

// //   const handleSubmit = async (event) => {
// //     event.preventDefault();

// //     if (!adminKey.trim()) {
// //       setError(
// //         'Enter your admin access key.'
// //       );

// //       return;
// //     }

// //     if (!form.fullName.trim()) {
// //       setError(
// //         'Dignitary full name is required.'
// //       );

// //       return;
// //     }

// //     setLoading(true);
// //     setError('');
// //     setCreated(null);
// //     setCopied(false);

// //     try {
// //       const response = await fetch(
// //         `${API_URL}/api/birthday/dignitary/create`,
// //         {
// //           method: 'POST',

// //           headers: {
// //             'Content-Type':
// //               'application/json',

// //             'x-admin-key':
// //               adminKey.trim(),
// //           },

// //           body: JSON.stringify({
// //             fullName:
// //               form.fullName.trim(),

// //             email:
// //               form.email.trim(),

// //             phone:
// //               form.phone.trim(),

// //             title:
// //               form.title.trim(),

// //             organization:
// //               form.organization.trim(),
// //           }),
// //         }
// //       );

// //       const result =
// //         await response.json();

// //       if (
// //         !response.ok ||
// //         !result.success
// //       ) {
// //         throw new Error(
// //           result.message ||
// //             'Unable to create this dignitary invitation.'
// //         );
// //       }

// //       setCreated(result.data);
// //       setForm(initialForm);

// //       // Automatically prepare the newly created code
// //       // for the "Open Invitation" feature.
// //       const newCode =
// //         normalizeInvitationCode(
// //           result.data?.invitationCode ||
// //             result.data?.invitationLink ||
// //             ''
// //         );

// //       if (newCode) {
// //         setInvitationCode(newCode);
// //       }
// //     } catch (err) {
// //       setError(
// //         err.message ||
// //           'Unable to create this dignitary invitation.'
// //       );
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const confirmAndOpenInvitation =
// //     async (rawCode) => {
// //       const code =
// //         normalizeInvitationCode(
// //           rawCode
// //         );

// //       if (!code) {
// //         setInvitationLookupError(
// //           'Enter a valid VIP invitation code.'
// //         );

// //         return;
// //       }

// //       setInvitationLookupLoading(true);
// //       setInvitationLookupError('');

// //       try {
// //         /**
// //          * Confirm that the invitation exists first.
// //          *
// //          * We do not navigate blindly.
// //          */
// //         const response = await fetch(
// //           `${API_URL}/api/birthday/invitation/${encodeURIComponent(
// //             code
// //           )}`
// //         );

// //         const result =
// //           await response.json();

// //         if (
// //           !response.ok ||
// //           !result.success
// //         ) {
// //           throw new Error(
// //             result.message ||
// //               'No VIP invitation was found with that code.'
// //           );
// //         }

// //         /**
// //          * Invitation confirmed.
// //          *
// //          * Open the exact same page the VIP sees.
// //          */
// //         navigate(
// //           `/invitation/${encodeURIComponent(
// //             code
// //           )}`
// //         );
// //       } catch (err) {
// //         setInvitationLookupError(
// //           err.message ||
// //             'Unable to confirm this invitation.'
// //         );
// //       } finally {
// //         setInvitationLookupLoading(
// //           false
// //         );
// //       }
// //     };

// //   const handleInvitationLookup =
// //     async (event) => {
// //       event.preventDefault();

// //       await confirmAndOpenInvitation(
// //         invitationCode
// //       );
// //     };

// //   const openCreatedInvitation =
// //     async () => {
// //       const code =
// //         normalizeInvitationCode(
// //           created?.invitationCode ||
// //             created?.invitationLink ||
// //             ''
// //         );

// //       if (!code) {
// //         setError(
// //           'The invitation was created, but no invitation code was returned.'
// //         );

// //         return;
// //       }

// //       await confirmAndOpenInvitation(
// //         code
// //       );
// //     };

// //   const copyInvitationLink =
// //     async () => {
// //       if (
// //         !created?.invitationLink
// //       ) {
// //         return;
// //       }

// //       try {
// //         await navigator.clipboard.writeText(
// //           created.invitationLink
// //         );

// //         setCopied(true);

// //         setTimeout(() => {
// //           setCopied(false);
// //         }, 2000);
// //       } catch {
// //         setError(
// //           'Could not copy automatically. Please copy the link manually.'
// //         );
// //       }
// //     };

// //   const createAnother = () => {
// //     setCreated(null);
// //     setCopied(false);
// //     setError('');
// //   };

// //   return (
// //     <div className="dignitary-admin-page">
// //       <div className="dignitary-admin-glow dignitary-admin-glow--one" />
// //       <div className="dignitary-admin-glow dignitary-admin-glow--two" />

// //       <motion.main
// //         className="dignitary-admin-card"
// //         initial={{
// //           opacity: 0,
// //           y: 24,
// //         }}
// //         animate={{
// //           opacity: 1,
// //           y: 0,
// //         }}
// //         transition={{
// //           duration: 0.45,
// //         }}
// //       >
// //         <div className="dignitary-admin-lock">
// //           VIP
// //         </div>

// //         <span className="dignitary-admin-eyebrow">
// //           Private
// //         </span>

// //         <h1>
// //           Create VIP Invitation
// //         </h1>

// //         <p className="dignitary-admin-intro">
// //           Create a private invitation for a VIP.
// //         </p>


// //         {/* =========================================
// //             OPEN EXISTING VIP INVITATION
// //         ========================================= */}

// //         <section className="dignitary-invite-access">
// //           <div className="dignitary-invite-access-heading">
// //             <span className="dignitary-invite-access-icon">
// //               ✦
// //             </span>

// //             <div>
// //               <strong>
// //                 Open Existing VIP Invitation
// //               </strong>

// //               <small>
// //                 Enter the invitation code to confirm and
// //                 preview the exact invitation page.
// //               </small>
// //             </div>
// //           </div>

// //           <form
// //             className="dignitary-invite-access-form"
// //             onSubmit={
// //               handleInvitationLookup
// //             }
// //           >
// //             <label htmlFor="vip-invitation-code">
// //               Invitation Code
// //             </label>

// //             <div className="dignitary-invite-access-row">
// //               <input
// //                 id="vip-invitation-code"
// //                 type="text"
// //                 value={invitationCode}
// //                 onChange={(event) => {
// //                   setInvitationCode(
// //                     event.target.value
// //                   );

// //                   if (
// //                     invitationLookupError
// //                   ) {
// //                     setInvitationLookupError(
// //                       ''
// //                     );
// //                   }
// //                 }}
// //                 placeholder="VIP-xxxxxxxx or paste the full invitation link"
// //                 autoComplete="off"
// //               />

// //               <button
// //                 type="submit"
// //                 disabled={
// //                   invitationLookupLoading
// //                 }
// //               >
// //                 {invitationLookupLoading
// //                   ? 'Confirming…'
// //                   : 'Confirm & View'}
// //               </button>
// //             </div>

// //             {invitationLookupError && (
// //               <div
// //                 className="dignitary-invite-access-error"
// //                 role="alert"
// //               >
// //                 {invitationLookupError}
// //               </div>
// //             )}

// //             <p>
// //               You can paste either the invitation code or the
// //               complete invitation link.
// //             </p>
// //           </form>
// //         </section>


// //         <div className="dignitary-admin-divider dignitary-admin-divider--major">
// //           <span />
// //           <b>
// //             CREATE NEW VIP
// //           </b>
// //           <span />
// //         </div>


// //         {error && (
// //           <div
// //             className="dignitary-admin-alert"
// //             role="alert"
// //           >
// //             {error}
// //           </div>
// //         )}


// //         {created ? (
// //           <motion.section
// //             className="dignitary-created"
// //             initial={{
// //               opacity: 0,
// //               scale: 0.98,
// //             }}
// //             animate={{
// //               opacity: 1,
// //               scale: 1,
// //             }}
// //           >
// //             <div className="dignitary-created-check">
// //               ✓
// //             </div>

// //             <span className="dignitary-created-label">
// //               Invitation Created
// //             </span>

// //             <h2>
// //               {created.fullName}
// //             </h2>

// //             {(
// //               created.title ||
// //               created.organization
// //             ) && (
// //               <p>
// //                 {[
// //                   created.title,
// //                   created.organization,
// //                 ]
// //                   .filter(Boolean)
// //                   .join(' · ')}
// //               </p>
// //             )}


// //             {/* INVITATION CODE */}

// //             {(created.invitationCode ||
// //               created.invitationLink) && (
// //               <div className="dignitary-created-code">
// //                 <span>
// //                   Invitation Code
// //                 </span>

// //                 <strong>
// //                   {normalizeInvitationCode(
// //                     created.invitationCode ||
// //                       created.invitationLink
// //                   )}
// //                 </strong>
// //               </div>
// //             )}


// //             <div className="dignitary-access-box">
// //               <span>
// //                 ACCESS
// //               </span>

// //               <strong>
// //                 ✓ Thanksgiving Service
// //               </strong>

// //               <strong>
// //                 ✓ Reception / Banquet
// //               </strong>
// //             </div>


// //             <div className="dignitary-link-box">
// //               <span>
// //                 Private Invitation Link
// //               </span>

// //               <input
// //                 type="text"
// //                 value={
// //                   created.invitationLink ||
// //                   ''
// //                 }
// //                 readOnly
// //               />

// //               <div className="dignitary-created-actions">
// //                 <button
// //                   type="button"
// //                   onClick={
// //                     copyInvitationLink
// //                   }
// //                 >
// //                   {copied
// //                     ? 'Copied ✓'
// //                     : 'Copy Invitation Link'}
// //                 </button>

// //                 <button
// //                   type="button"
// //                   className="dignitary-view-button"
// //                   onClick={
// //                     openCreatedInvitation
// //                   }
// //                   disabled={
// //                     invitationLookupLoading
// //                   }
// //                 >
// //                   View VIP Invitation
// //                 </button>
// //               </div>
// //             </div>


// //             <p className="dignitary-private-note">
// //               Send the private link directly to the
// //               dignitary. The VIP invitation route does not
// //               need to appear in your website navigation.
// //             </p>


// //             <button
// //               type="button"
// //               className="dignitary-secondary-button"
// //               onClick={
// //                 createAnother
// //               }
// //             >
// //               Create Another Invitation
// //             </button>
// //           </motion.section>
// //         ) : (
// //           <form
// //             className="dignitary-admin-form"
// //             onSubmit={handleSubmit}
// //           >
// //             <div className="dignitary-admin-field dignitary-admin-field--secret">
// //               <label htmlFor="dignitary-admin-key">
// //                 Admin Access Key
// //               </label>

// //               <input
// //                 id="dignitary-admin-key"
// //                 type="password"
// //                 value={adminKey}
// //                 onChange={(event) => {
// //                   setAdminKey(
// //                     event.target.value
// //                   );

// //                   if (error) {
// //                     setError('');
// //                   }
// //                 }}
// //                 placeholder="Enter your private admin key"
// //                 autoComplete="off"
// //                 required
// //               />

// //               <small>
// //                 The key is used only when creating the VIP
// //                 invitation.
// //               </small>
// //             </div>


// //             <div className="dignitary-admin-divider">
// //               <span />
// //               <b>
// //                 VIP DETAILS
// //               </b>
// //               <span />
// //             </div>


// //             <div className="dignitary-admin-field">
// //               <label htmlFor="dignitary-full-name">
// //                 Full Name
// //               </label>

// //               <input
// //                 id="dignitary-full-name"
// //                 name="fullName"
// //                 type="text"
// //                 value={form.fullName}
// //                 onChange={
// //                   handleChange
// //                 }
// //                 placeholder="e.g. Esteemed Pastor Jane Doe"
// //                 required
// //               />
// //             </div>


// //             <div className="dignitary-admin-grid">
// //               <div className="dignitary-admin-field">
// //                 <label htmlFor="dignitary-title">
// //                   Title
// //                 </label>

// //                 <input
// //                   id="dignitary-title"
// //                   name="title"
// //                   type="text"
// //                   value={form.title}
// //                   onChange={
// //                     handleChange
// //                   }
// //                   placeholder="e.g. Esteemed Pastor"
// //                 />
// //               </div>

// //               <div className="dignitary-admin-field">
// //                 <label htmlFor="dignitary-organization">
// //                   Ministry / Zone
// //                 </label>

// //                 <input
// //                   id="dignitary-organization"
// //                   name="organization"
// //                   type="text"
// //                   value={
// //                     form.organization
// //                   }
// //                   onChange={
// //                     handleChange
// //                   }
// //                   placeholder="e.g. Loveworld"
// //                 />
// //               </div>
// //             </div>


// //             <div className="dignitary-admin-grid">
// //               <div className="dignitary-admin-field">
// //                 <label htmlFor="dignitary-email">
// //                   Email
// //                 </label>

// //                 <input
// //                   id="dignitary-email"
// //                   name="email"
// //                   type="email"
// //                   value={form.email}
// //                   onChange={
// //                     handleChange
// //                   }
// //                   placeholder="Optional"
// //                   autoComplete="email"
// //                 />
// //               </div>

// //               <div className="dignitary-admin-field">
// //                 <label htmlFor="dignitary-phone">
// //                   Phone
// //                 </label>

// //                 <input
// //                   id="dignitary-phone"
// //                   name="phone"
// //                   type="tel"
// //                   value={form.phone}
// //                   onChange={
// //                     handleChange
// //                   }
// //                   placeholder="Optional"
// //                   autoComplete="tel"
// //                 />
// //               </div>
// //             </div>


// //             <motion.button
// //               type="submit"
// //               className="dignitary-admin-submit"
// //               disabled={loading}
// //               whileHover={
// //                 !loading
// //                   ? {
// //                       scale: 1.01,
// //                     }
// //                   : {}
// //               }
// //               whileTap={
// //                 !loading
// //                   ? {
// //                       scale: 0.99,
// //                     }
// //                   : {}
// //               }
// //             >
// //               {loading
// //                 ? 'Creating Invitation…'
// //                 : 'Create Private Invitation'}
// //             </motion.button>
// //           </form>
// //         )}
// //       </motion.main>
// //     </div>
// //   );
// // }





// import React, { useState } from 'react';
// import { motion } from 'framer-motion';
// import { useNavigate } from 'react-router-dom';
// import './DignitaryAdmin.css';

// const API_URL =
//   process.env.REACT_APP_API_URL || 'https://lsdcnodejs-api.onrender.com';


// const PasswordEyeIcon = ({ visible }) => (
//   visible ? (
//     <svg
//       width="20"
//       height="20"
//       viewBox="0 0 24 24"
//       fill="none"
//       aria-hidden="true"
//     >
//       <path
//         d="M3 3L21 21"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//       />
//       <path
//         d="M10.6 10.7A2 2 0 0013.3 13.4"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//       />
//       <path
//         d="M9.9 4.3A10.6 10.6 0 0112 4c5.4 0 9 5.2 9 5.2a14.4 14.4 0 01-3 3.6M6.1 6.1C4.2 7.3 3 9.2 3 9.2S6.6 14.4 12 14.4c1 0 1.9-.2 2.7-.5"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   ) : (
//     <svg
//       width="20"
//       height="20"
//       viewBox="0 0 24 24"
//       fill="none"
//       aria-hidden="true"
//     >
//       <path
//         d="M3 12s3.6-5.2 9-5.2S21 12 21 12s-3.6 5.2-9 5.2S3 12 3 12z"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <circle
//         cx="12"
//         cy="12"
//         r="2.6"
//         stroke="currentColor"
//         strokeWidth="1.8"
//       />
//     </svg>
//   )
// );


// const passwordWrapStyle = {
//   position: 'relative',
//   width: '100%',
// };


// const passwordInputStyle = {
//   width: '100%',
//   boxSizing: 'border-box',
//   paddingRight: '48px',
// };


// const passwordEyeButtonStyle = {
//   position: 'absolute',
//   top: '50%',
//   right: '14px',
//   transform: 'translateY(-50%)',
//   width: '32px',
//   minWidth: '32px',
//   height: '32px',
//   minHeight: '32px',
//   padding: 0,
//   margin: 0,
//   display: 'grid',
//   placeItems: 'center',
//   border: 'none',
//   borderRadius: '50%',
//   background: 'transparent',
//   boxShadow: 'none',
//   color: '#c6a15b',
//   cursor: 'pointer',
//   zIndex: 3,
// };


// const initialForm = {
//   fullName: '',
//   email: '',
//   phone: '',
//   title: '',
//   organization: '',
// };

// const normalizeInvitationCode = (value = '') => {
//   const raw = value.trim();

//   if (!raw) return '';

//   // Allows you to paste either:
//   // VIP-xxxxxxxx
//   // OR the complete invitation URL.
//   try {
//     if (
//       raw.startsWith('http://') ||
//       raw.startsWith('https://')
//     ) {
//       const url = new URL(raw);
//       const parts = url.pathname
//         .split('/')
//         .filter(Boolean);

//       const invitationIndex =
//         parts.indexOf('invitation');

//       if (
//         invitationIndex !== -1 &&
//         parts[invitationIndex + 1]
//       ) {
//         return decodeURIComponent(
//           parts[invitationIndex + 1]
//         );
//       }

//       return decodeURIComponent(
//         parts[parts.length - 1] || ''
//       );
//     }
//   } catch {
//     // Fall through and treat the input as a raw code.
//   }

//   // Also handles someone pasting:
//   // /invitation/VIP-xxxxx
//   const inviteMarker = '/invitation/';

//   if (raw.includes(inviteMarker)) {
//     return decodeURIComponent(
//       raw
//         .split(inviteMarker)
//         .pop()
//         .split('?')[0]
//         .split('#')[0]
//         .replace(/\/+$/, '')
//     );
//   }

//   return raw
//     .split('?')[0]
//     .split('#')[0]
//     .replace(/\/+$/, '');
// };

// export default function DignitaryAdmin() {
//   const navigate = useNavigate();

//   const [form, setForm] = useState(initialForm);
//   const [adminKey, setAdminKey] = useState('');
//   const [showAdminKey, setShowAdminKey] = useState(false);

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');

//   const [created, setCreated] = useState(null);
//   const [copied, setCopied] = useState(false);

//   // Existing VIP invitation access
//   const [invitationCode, setInvitationCode] =
//     useState('');

//   const [
//     invitationLookupLoading,
//     setInvitationLookupLoading,
//   ] = useState(false);

//   const [
//     invitationLookupError,
//     setInvitationLookupError,
//   ] = useState('');

//   const handleChange = (event) => {
//     const { name, value } = event.target;

//     setForm((current) => ({
//       ...current,
//       [name]: value,
//     }));

//     if (error) {
//       setError('');
//     }
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();

//     if (!adminKey.trim()) {
//       setError(
//         'Enter your admin access key.'
//       );

//       return;
//     }

//     if (!form.fullName.trim()) {
//       setError(
//         'Dignitary full name is required.'
//       );

//       return;
//     }

//     setLoading(true);
//     setError('');
//     setCreated(null);
//     setCopied(false);

//     try {
//       const response = await fetch(
//         `${API_URL}/api/birthday/dignitary/create`,
//         {
//           method: 'POST',

//           headers: {
//             'Content-Type':
//               'application/json',

//             'x-admin-key':
//               adminKey.trim(),
//           },

//           body: JSON.stringify({
//             fullName:
//               form.fullName.trim(),

//             email:
//               form.email.trim(),

//             phone:
//               form.phone.trim(),

//             title:
//               form.title.trim(),

//             organization:
//               form.organization.trim(),
//           }),
//         }
//       );

//       const result =
//         await response.json();

//       if (
//         !response.ok ||
//         !result.success
//       ) {
//         throw new Error(
//           result.message ||
//             'Unable to create this dignitary invitation.'
//         );
//       }

//       setCreated(result.data);
//       setForm(initialForm);

//       // Automatically prepare the newly created code
//       // for the "Open Invitation" feature.
//       const newCode =
//         normalizeInvitationCode(
//           result.data?.invitationCode ||
//             result.data?.invitationLink ||
//             ''
//         );

//       if (newCode) {
//         setInvitationCode(newCode);
//       }
//     } catch (err) {
//       setError(
//         err.message ||
//           'Unable to create this dignitary invitation.'
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const confirmAndOpenInvitation =
//     async (rawCode) => {
//       const code =
//         normalizeInvitationCode(
//           rawCode
//         );

//       if (!code) {
//         setInvitationLookupError(
//           'Enter a valid VIP invitation code.'
//         );

//         return;
//       }

//       setInvitationLookupLoading(true);
//       setInvitationLookupError('');

//       try {
//         /**
//          * Confirm that the invitation exists first.
//          *
//          * We do not navigate blindly.
//          */
//         const response = await fetch(
//           `${API_URL}/api/birthday/invitation/${encodeURIComponent(
//             code
//           )}`
//         );

//         const result =
//           await response.json();

//         if (
//           !response.ok ||
//           !result.success
//         ) {
//           throw new Error(
//             result.message ||
//               'No VIP invitation was found with that code.'
//           );
//         }

//         /**
//          * Invitation confirmed.
//          *
//          * Open the exact same page the VIP sees.
//          */
//         navigate(
//           `/invitation/${encodeURIComponent(
//             code
//           )}`
//         );
//       } catch (err) {
//         setInvitationLookupError(
//           err.message ||
//             'Unable to confirm this invitation.'
//         );
//       } finally {
//         setInvitationLookupLoading(
//           false
//         );
//       }
//     };

//   const handleInvitationLookup =
//     async (event) => {
//       event.preventDefault();

//       await confirmAndOpenInvitation(
//         invitationCode
//       );
//     };

//   const openCreatedInvitation =
//     async () => {
//       const code =
//         normalizeInvitationCode(
//           created?.invitationCode ||
//             created?.invitationLink ||
//             ''
//         );

//       if (!code) {
//         setError(
//           'The invitation was created, but no invitation code was returned.'
//         );

//         return;
//       }

//       await confirmAndOpenInvitation(
//         code
//       );
//     };

//   const copyInvitationLink =
//     async () => {
//       if (
//         !created?.invitationLink
//       ) {
//         return;
//       }

//       try {
//         await navigator.clipboard.writeText(
//           created.invitationLink
//         );

//         setCopied(true);

//         setTimeout(() => {
//           setCopied(false);
//         }, 2000);
//       } catch {
//         setError(
//           'Could not copy automatically. Please copy the link manually.'
//         );
//       }
//     };

//   const createAnother = () => {
//     setCreated(null);
//     setCopied(false);
//     setError('');
//   };

//   return (
//     <div className="dignitary-admin-page">
//       <div className="dignitary-admin-glow dignitary-admin-glow--one" />
//       <div className="dignitary-admin-glow dignitary-admin-glow--two" />

//       <motion.main
//         className="dignitary-admin-card"
//         initial={{
//           opacity: 0,
//           y: 24,
//         }}
//         animate={{
//           opacity: 1,
//           y: 0,
//         }}
//         transition={{
//           duration: 0.45,
//         }}
//       >
//         <div className="dignitary-admin-lock">
//           VIP
//         </div>

//         <span className="dignitary-admin-eyebrow">
//           Private
//         </span>

//         <h1>
//           Create VIP Invitation
//         </h1>

//         <p className="dignitary-admin-intro">
//           Create a private invitation for a VIP.
//         </p>


//         {/* =========================================
//             OPEN EXISTING VIP INVITATION
//         ========================================= */}

//         <section className="dignitary-invite-access">
//           <div className="dignitary-invite-access-heading">
//             <span className="dignitary-invite-access-icon">
//               ✦
//             </span>

//             <div>
//               <strong>
//                 Open Existing VIP Invitation
//               </strong>

//               <small>
//                 Enter the invitation code to confirm and
//                 preview the exact invitation page.
//               </small>
//             </div>
//           </div>

//           <form
//             className="dignitary-invite-access-form"
//             onSubmit={
//               handleInvitationLookup
//             }
//           >
//             <label htmlFor="vip-invitation-code">
//               Invitation Code
//             </label>

//             <div className="dignitary-invite-access-row">
//               <input
//                 id="vip-invitation-code"
//                 type="text"
//                 value={invitationCode}
//                 onChange={(event) => {
//                   setInvitationCode(
//                     event.target.value
//                   );

//                   if (
//                     invitationLookupError
//                   ) {
//                     setInvitationLookupError(
//                       ''
//                     );
//                   }
//                 }}
//                 placeholder="VIP-xxxxxxxx or paste the full invitation link"
//                 autoComplete="off"
//               />

//               <button
//                 type="submit"
//                 disabled={
//                   invitationLookupLoading
//                 }
//               >
//                 {invitationLookupLoading
//                   ? 'Confirming…'
//                   : 'Confirm & View'}
//               </button>
//             </div>

//             {invitationLookupError && (
//               <div
//                 className="dignitary-invite-access-error"
//                 role="alert"
//               >
//                 {invitationLookupError}
//               </div>
//             )}

//             <p>
//               You can paste either the invitation code or the
//               complete invitation link.
//             </p>
//           </form>
//         </section>


//         <div className="dignitary-admin-divider dignitary-admin-divider--major">
//           <span />
//           <b>
//             CREATE NEW VIP
//           </b>
//           <span />
//         </div>


//         {error && (
//           <div
//             className="dignitary-admin-alert"
//             role="alert"
//           >
//             {error}
//           </div>
//         )}


//         {created ? (
//           <motion.section
//             className="dignitary-created"
//             initial={{
//               opacity: 0,
//               scale: 0.98,
//             }}
//             animate={{
//               opacity: 1,
//               scale: 1,
//             }}
//           >
//             <div className="dignitary-created-check">
//               ✓
//             </div>

//             <span className="dignitary-created-label">
//               Invitation Created
//             </span>

//             <h2>
//               {created.fullName}
//             </h2>

//             {(
//               created.title ||
//               created.organization
//             ) && (
//               <p>
//                 {[
//                   created.title,
//                   created.organization,
//                 ]
//                   .filter(Boolean)
//                   .join(' · ')}
//               </p>
//             )}


//             {/* INVITATION CODE */}

//             {(created.invitationCode ||
//               created.invitationLink) && (
//               <div className="dignitary-created-code">
//                 <span>
//                   Invitation Code
//                 </span>

//                 <strong>
//                   {normalizeInvitationCode(
//                     created.invitationCode ||
//                       created.invitationLink
//                   )}
//                 </strong>
//               </div>
//             )}


//             <div className="dignitary-access-box">
//               <span>
//                 ACCESS
//               </span>

//               <strong>
//                 ✓ Thanksgiving Service
//               </strong>

//               <strong>
//                 ✓ Reception / Banquet
//               </strong>
//             </div>


//             <div className="dignitary-link-box">
//               <span>
//                 Private Invitation Link
//               </span>

//               <input
//                 type="text"
//                 value={
//                   created.invitationLink ||
//                   ''
//                 }
//                 readOnly
//               />

//               <div className="dignitary-created-actions">
//                 <button
//                   type="button"
//                   onClick={
//                     copyInvitationLink
//                   }
//                 >
//                   {copied
//                     ? 'Copied ✓'
//                     : 'Copy Invitation Link'}
//                 </button>

//                 <button
//                   type="button"
//                   className="dignitary-view-button"
//                   onClick={
//                     openCreatedInvitation
//                   }
//                   disabled={
//                     invitationLookupLoading
//                   }
//                 >
//                   View VIP Invitation
//                 </button>
//               </div>
//             </div>


//             <p className="dignitary-private-note">
//               Send the private link directly to the
//               dignitary. The VIP invitation route does not
//               need to appear in your website navigation.
//             </p>


//             <button
//               type="button"
//               className="dignitary-secondary-button"
//               onClick={
//                 createAnother
//               }
//             >
//               Create Another Invitation
//             </button>
//           </motion.section>
//         ) : (
//           <form
//             className="dignitary-admin-form"
//             onSubmit={handleSubmit}
//           >
//             <div className="dignitary-admin-field dignitary-admin-field--secret">
//               <label htmlFor="dignitary-admin-key">
//                 Admin Access Key
//               </label>

//               <div style={passwordWrapStyle}>
//                 <input
//                   id="dignitary-admin-key"
//                   type={
//                     showAdminKey
//                       ? 'text'
//                       : 'password'
//                   }
//                   value={adminKey}
//                   onChange={(event) => {
//                     setAdminKey(
//                       event.target.value
//                     );

//                     if (error) {
//                       setError('');
//                     }
//                   }}
//                   placeholder="Enter your private admin key"
//                   autoComplete="off"
//                   required
//                   style={passwordInputStyle}
//                 />

//                 <button
//                   type="button"
//                   onClick={() =>
//                     setShowAdminKey(
//                       (current) => !current
//                     )
//                   }
//                   aria-label={
//                     showAdminKey
//                       ? 'Hide admin access key'
//                       : 'Show admin access key'
//                   }
//                   title={
//                     showAdminKey
//                       ? 'Hide password'
//                       : 'Show password'
//                   }
//                   style={passwordEyeButtonStyle}
//                 >
//                   <PasswordEyeIcon
//                     visible={showAdminKey}
//                   />
//                 </button>
//               </div>

//               <small>
//                 The key is used only when creating the VIP
//                 invitation.
//               </small>
//             </div>


//             <div className="dignitary-admin-divider">
//               <span />
//               <b>
//                 VIP DETAILS
//               </b>
//               <span />
//             </div>


//             <div className="dignitary-admin-field">
//               <label htmlFor="dignitary-full-name">
//                 Full Name
//               </label>

//               <input
//                 id="dignitary-full-name"
//                 name="fullName"
//                 type="text"
//                 value={form.fullName}
//                 onChange={
//                   handleChange
//                 }
//                 placeholder="e.g. Esteemed Pastor Jane Doe"
//                 required
//               />
//             </div>


//             <div className="dignitary-admin-grid">
//               {/* <div className="dignitary-admin-field">
//                 <label htmlFor="dignitary-title">
//                   Title
//                 </label>

//                 <input
//                   id="dignitary-title"
//                   name="title"
//                   type="text"
//                   value={form.title}
//                   onChange={
//                     handleChange
//                   }
//                   placeholder="e.g. Esteemed Pastor"
//                 />
//               </div> */}

//               {/* <div className="dignitary-admin-field">
//                 <label htmlFor="dignitary-organization">
//                   Ministry / Zone
//                 </label>

//                 <input
//                   id="dignitary-organization"
//                   name="organization"
//                   type="text"
//                   value={
//                     form.organization
//                   }
//                   onChange={
//                     handleChange
//                   }
//                   placeholder="e.g. Loveworld"
//                 />
//               </div> */}
//             </div>


//             <div className="dignitary-admin-grid">
//               {/* <div className="dignitary-admin-field">
//                 <label htmlFor="dignitary-email">
//                   Email
//                 </label>

//                 <input
//                   id="dignitary-email"
//                   name="email"
//                   type="email"
//                   value={form.email}
//                   onChange={
//                     handleChange
//                   }
//                   placeholder="Optional"
//                   autoComplete="email"
//                 />
//               </div> */}

//               {/* <div className="dignitary-admin-field">
//                 <label htmlFor="dignitary-phone">
//                   Phone
//                 </label>

//                 <input
//                   id="dignitary-phone"
//                   name="phone"
//                   type="tel"
//                   value={form.phone}
//                   onChange={
//                     handleChange
//                   }
//                   placeholder="Optional"
//                   autoComplete="tel"
//                 />
//               </div> */}
//             </div>


//             <motion.button
//               type="submit"
//               className="dignitary-admin-submit"
//               disabled={loading}
//               whileHover={
//                 !loading
//                   ? {
//                       scale: 1.01,
//                     }
//                   : {}
//               }
//               whileTap={
//                 !loading
//                   ? {
//                       scale: 0.99,
//                     }
//                   : {}
//               }
//             >
//               {loading
//                 ? 'Creating Invitation…'
//                 : 'Create Private Invitation'}
//             </motion.button>
//           </form>
//         )}
//       </motion.main>
//     </div>
//   );
// }


//Admin Access Key

import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import './DignitaryAdmin.css';

const API_URL =
  process.env.REACT_APP_API_URL || 'https://lsdcnodejs-api.onrender.com';


const PasswordEyeIcon = ({ visible }) => (
  visible ? (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M3 3L21 21"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M10.6 10.7A2 2 0 0013.3 13.4"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M9.9 4.3A10.6 10.6 0 0112 4c5.4 0 9 5.2 9 5.2a14.4 14.4 0 01-3 3.6M6.1 6.1C4.2 7.3 3 9.2 3 9.2S6.6 14.4 12 14.4c1 0 1.9-.2 2.7-.5"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M3 12s3.6-5.2 9-5.2S21 12 21 12s-3.6 5.2-9 5.2S3 12 3 12z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="12"
        r="2.6"
        stroke="currentColor"
        strokeWidth="1.8"
      />
    </svg>
  )
);


const passwordWrapStyle = {
  position: 'relative',
  width: '100%',
};


const passwordInputStyle = {
  width: '100%',
  boxSizing: 'border-box',
  paddingRight: '48px',
};


const passwordEyeButtonStyle = {
  position: 'absolute',
  top: '50%',
  right: '14px',
  transform: 'translateY(-50%)',
  width: '32px',
  minWidth: '32px',
  height: '32px',
  minHeight: '32px',
  padding: 0,
  margin: 0,
  display: 'grid',
  placeItems: 'center',
  border: 'none',
  borderRadius: '50%',
  background: 'transparent',
  boxShadow: 'none',
  color: '#c6a15b',
  cursor: 'pointer',
  zIndex: 3,
};


const initialForm = {
  fullName: '',
  email: '',
  phone: '',
  title: '',
  organization: '',
};

const normalizeInvitationCode = (value = '') => {
  const raw = value.trim();

  if (!raw) return '';

  // Allows you to paste either:
  // VIP-xxxxxxxx
  // OR the complete invitation URL.
  try {
    if (
      raw.startsWith('http://') ||
      raw.startsWith('https://')
    ) {
      const url = new URL(raw);
      const parts = url.pathname
        .split('/')
        .filter(Boolean);

      const invitationIndex =
        parts.indexOf('invitation');

      if (
        invitationIndex !== -1 &&
        parts[invitationIndex + 1]
      ) {
        return decodeURIComponent(
          parts[invitationIndex + 1]
        );
      }

      return decodeURIComponent(
        parts[parts.length - 1] || ''
      );
    }
  } catch {
    // Fall through and treat the input as a raw code.
  }

  // Also handles someone pasting:
  // /invitation/VIP-xxxxx
  const inviteMarker = '/invitation/';

  if (raw.includes(inviteMarker)) {
    return decodeURIComponent(
      raw
        .split(inviteMarker)
        .pop()
        .split('?')[0]
        .split('#')[0]
        .replace(/\/+$/, '')
    );
  }

  return raw
    .split('?')[0]
    .split('#')[0]
    .replace(/\/+$/, '');
};

export default function DignitaryAdmin() {
  const navigate = useNavigate();

  const [form, setForm] = useState(initialForm);
  const [adminKey, setAdminKey] = useState('');
  const [showAdminKey, setShowAdminKey] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [created, setCreated] = useState(null);
  const [copiedLink, setCopiedLink] = useState(false);
  const [copiedCode, setCopiedCode] = useState(false);

  // Existing VIP invitation access
  const [invitationCode, setInvitationCode] =
    useState('');

  const [
    invitationLookupLoading,
    setInvitationLookupLoading,
  ] = useState(false);

  const [
    invitationLookupError,
    setInvitationLookupError,
  ] = useState('');

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((current) => ({
      ...current,
      [name]: value,
    }));

    if (error) {
      setError('');
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!adminKey.trim()) {
      setError(
        'Enter your admin access key.'
      );

      return;
    }

    if (!form.fullName.trim()) {
      setError(
        'Dignitary full name is required.'
      );

      return;
    }

    setLoading(true);
    setError('');
    setCreated(null);
    setCopiedLink(false);
    setCopiedCode(false);

    try {
      const response = await fetch(
        `${API_URL}/api/birthday/dignitary/create`,
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            'x-admin-key':
              adminKey.trim(),
          },

          body: JSON.stringify({
            fullName:
              form.fullName.trim(),

            email:
              form.email.trim(),

            phone:
              form.phone.trim(),

            title:
              form.title.trim(),

            organization:
              form.organization.trim(),
          }),
        }
      );

      const result =
        await response.json();

      if (
        !response.ok ||
        !result.success
      ) {
        throw new Error(
          result.message ||
            'Unable to create this dignitary invitation.'
        );
      }

      setCreated(result.data);
      setForm(initialForm);

      // Automatically prepare the newly created code
      // for the "Open Invitation" feature.
      const newCode =
        normalizeInvitationCode(
          result.data?.invitationCode ||
            result.data?.invitationLink ||
            ''
        );

      if (newCode) {
        setInvitationCode(newCode);
      }
    } catch (err) {
      setError(
        err.message ||
          'Unable to create this dignitary invitation.'
      );
    } finally {
      setLoading(false);
    }
  };

  const confirmAndOpenInvitation =
    async (rawCode) => {
      const code =
        normalizeInvitationCode(
          rawCode
        );

      if (!code) {
        setInvitationLookupError(
          'Enter a valid VIP invitation code.'
        );

        return;
      }

      setInvitationLookupLoading(true);
      setInvitationLookupError('');

      try {
        /**
         * Confirm that the invitation exists first.
         *
         * We do not navigate blindly.
         */
        const response = await fetch(
          `${API_URL}/api/birthday/invitation/${encodeURIComponent(
            code
          )}`
        );

        const result =
          await response.json();

        if (
          !response.ok ||
          !result.success
        ) {
          throw new Error(
            result.message ||
              'No VIP invitation was found with that code.'
          );
        }

        /**
         * Invitation confirmed.
         *
         * Open the exact same page the VIP sees.
         */
        navigate(
          `/invitation/${encodeURIComponent(
            code
          )}`
        );
      } catch (err) {
        setInvitationLookupError(
          err.message ||
            'Unable to confirm this invitation.'
        );
      } finally {
        setInvitationLookupLoading(
          false
        );
      }
    };

  const handleInvitationLookup =
    async (event) => {
      event.preventDefault();

      await confirmAndOpenInvitation(
        invitationCode
      );
    };

  const openCreatedInvitation =
    async () => {
      const code =
        normalizeInvitationCode(
          created?.invitationCode ||
            created?.invitationLink ||
            ''
        );

      if (!code) {
        setError(
          'The invitation was created, but no invitation code was returned.'
        );

        return;
      }

      await confirmAndOpenInvitation(
        code
      );
    };

  const copyTextToClipboard = async (text) => {
    const value = String(text || '').trim();

    if (!value) {
      throw new Error('There is nothing to copy.');
    }

    if (
      navigator.clipboard &&
      window.isSecureContext
    ) {
      await navigator.clipboard.writeText(value);
      return;
    }

    const textarea =
      document.createElement('textarea');

    textarea.value = value;
    textarea.setAttribute('readonly', '');

    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '0';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);

    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(
      0,
      textarea.value.length
    );

    const copied =
      document.execCommand('copy');

    document.body.removeChild(textarea);

    if (!copied) {
      throw new Error('Copy failed.');
    }
  };


  const getCreatedInvitationCode = () =>
    normalizeInvitationCode(
      created?.invitationCode ||
        created?.invitationLink ||
        ''
    );


  const getCreatedInvitationLink = () => {
    const code =
      getCreatedInvitationCode();

    if (!code) {
      return (
        created?.invitationLink ||
        ''
      );
    }

    if (
      typeof window !== 'undefined' &&
      window.location?.origin
    ) {
      return `${window.location.origin}/invitation/${encodeURIComponent(
        code
      )}`;
    }

    return (
      created?.invitationLink ||
      `/invitation/${encodeURIComponent(
        code
      )}`
    );
  };


  const copyInvitationLink = async () => {
    const invitationLink =
      getCreatedInvitationLink();

    if (!invitationLink) {
      setError(
        'No invitation link is available to copy.'
      );
      return;
    }

    try {
      await copyTextToClipboard(
        invitationLink
      );

      setCopiedLink(true);
      setCopiedCode(false);

      setTimeout(() => {
        setCopiedLink(false);
      }, 2000);
    } catch (err) {
      console.error(
        'Copy invitation link error:',
        err
      );

      setError(
        'Could not copy the invitation link automatically. Please copy it manually.'
      );
    }
  };


  const copyInvitationCode = async () => {
    const code =
      getCreatedInvitationCode();

    if (!code) {
      setError(
        'No invitation code is available to copy.'
      );
      return;
    }

    try {
      await copyTextToClipboard(
        code
      );

      setCopiedCode(true);
      setCopiedLink(false);

      setTimeout(() => {
        setCopiedCode(false);
      }, 2000);
    } catch (err) {
      console.error(
        'Copy invitation code error:',
        err
      );

      setError(
        'Could not copy the invitation code automatically. Please copy it manually.'
      );
    }
  };

  const createAnother = () => {
    setCreated(null);
    setCopiedLink(false);
    setCopiedCode(false);
    setError('');
  };

  return (
    <div className="dignitary-admin-page">
      <div className="dignitary-admin-glow dignitary-admin-glow--one" />
      <div className="dignitary-admin-glow dignitary-admin-glow--two" />

      <motion.main
        className="dignitary-admin-card"
        initial={{
          opacity: 0,
          y: 24,
        }}
        animate={{
          opacity: 1,
          y: 0,
        }}
        transition={{
          duration: 0.45,
        }}
      >
        <div className="dignitary-admin-lock">
          VIP
        </div>

        <span className="dignitary-admin-eyebrow">
          Private
        </span>

        <h1>
          Create VIP Invitation
        </h1>

        <p className="dignitary-admin-intro">
          Create a private invitation for a VIP.
        </p>


        {/* =========================================
            OPEN EXISTING VIP INVITATION
        ========================================= */}

        <section className="dignitary-invite-access">
          <div className="dignitary-invite-access-heading">
            <span className="dignitary-invite-access-icon">
              ✦
            </span>

            <div>
              <strong>
                Open Existing VIP Invitation
              </strong>

              <small>
                Enter the invitation code to confirm and
                preview the exact invitation page.
              </small>
            </div>
          </div>

          <form
            className="dignitary-invite-access-form"
            onSubmit={
              handleInvitationLookup
            }
          >
            <label htmlFor="vip-invitation-code">
              Invitation Code
            </label>

            <div className="dignitary-invite-access-row">
              <input
                id="vip-invitation-code"
                type="text"
                value={invitationCode}
                onChange={(event) => {
                  setInvitationCode(
                    event.target.value
                  );

                  if (
                    invitationLookupError
                  ) {
                    setInvitationLookupError(
                      ''
                    );
                  }
                }}
                placeholder="VIP-xxxxxxxx or paste the full invitation link"
                autoComplete="off"
              />

              <button
                type="submit"
                disabled={
                  invitationLookupLoading
                }
              >
                {invitationLookupLoading
                  ? 'Confirming…'
                  : 'Confirm & View'}
              </button>
            </div>

            {invitationLookupError && (
              <div
                className="dignitary-invite-access-error"
                role="alert"
              >
                {invitationLookupError}
              </div>
            )}

            <p>
              You can paste either the invitation code or the
              complete invitation link.
            </p>
          </form>
        </section>


        {/* <div className="dignitary-admin-divider dignitary-admin-divider--major">
          <span />
          <b>
            CREATE NEW VIP
          </b>
          <span />
        </div> */}


        {error && (
          <div
            className="dignitary-admin-alert"
            role="alert"
          >
            {error}
          </div>
        )}


        {created ? (
          <motion.section
            className="dignitary-created"
            initial={{
              opacity: 0,
              scale: 0.98,
            }}
            animate={{
              opacity: 1,
              scale: 1,
            }}
          >
            <div className="dignitary-created-check">
              ✓
            </div>

            <span className="dignitary-created-label">
              Invitation Created
            </span>

            <h2>
              {created.fullName}
            </h2>

            {(
              created.title ||
              created.organization
            ) && (
              <p>
                {[
                  created.title,
                  created.organization,
                ]
                  .filter(Boolean)
                  .join(' · ')}
              </p>
            )}


            {/* INVITATION CODE */}

            {(created.invitationCode ||
              created.invitationLink) && (
              <div className="dignitary-created-code">
                <span>
                  Invitation Code
                </span>

                <strong>
                  {getCreatedInvitationCode()}
                </strong>

                <button
                  type="button"
                  className="dignitary-copy-code-button"
                  onClick={copyInvitationCode}
                >
                  {copiedCode
                    ? 'Code Copied ✓'
                    : 'Copy Invitation Code'}
                </button>
              </div>
            )}


            <div className="dignitary-access-box">
              <span>
                ACCESS
              </span>

              <strong>
                ✓ Thanksgiving Service
              </strong>

              <strong>
                ✓ Reception / Banquet
              </strong>
            </div>


            <div className="dignitary-link-box">
              <span>
                Private Invitation Link
              </span>

              <input
                type="text"
                value={
                  getCreatedInvitationLink()
                }
                readOnly
              />

              <div className="dignitary-created-actions">
                <button
                  type="button"
                  onClick={
                    copyInvitationLink
                  }
                >
                  {copiedLink
                    ? 'Link Copied ✓'
                    : 'Copy Invitation Link'}
                </button>

                <button
                  type="button"
                  className="dignitary-view-button"
                  onClick={
                    openCreatedInvitation
                  }
                  disabled={
                    invitationLookupLoading
                  }
                >
                  View VIP Invitation
                </button>
              </div>
            </div>


            <p className="dignitary-private-note">
              Send the private link directly to the
              dignitary. The VIP invitation route does not
              need to appear in your website navigation.
            </p>


            <button
              type="button"
              className="dignitary-secondary-button"
              onClick={
                createAnother
              }
            >
              Create Another Invitation
            </button>
          </motion.section>
        ) : (
          <form
            className="dignitary-admin-form"
            onSubmit={handleSubmit}
          >
            {/* <div className="dignitary-admin-field dignitary-admin-field--secret">
              <label htmlFor="dignitary-admin-key">
                Admin Access Key
              </label>

              <div style={passwordWrapStyle}>
                <input
                  id="dignitary-admin-key"
                  type={
                    showAdminKey
                      ? 'text'
                      : 'password'
                  }
                  value={adminKey}
                  onChange={(event) => {
                    setAdminKey(
                      event.target.value
                    );

                    if (error) {
                      setError('');
                    }
                  }}
                  placeholder="Enter your private admin key"
                  autoComplete="off"
                  required
                  style={passwordInputStyle}
                />

                <button
                  type="button"
                  onClick={() =>
                    setShowAdminKey(
                      (current) => !current
                    )
                  }
                  aria-label={
                    showAdminKey
                      ? 'Hide admin access key'
                      : 'Show admin access key'
                  }
                  title={
                    showAdminKey
                      ? 'Hide password'
                      : 'Show password'
                  }
                  style={passwordEyeButtonStyle}
                >
                  <PasswordEyeIcon
                    visible={showAdminKey}
                  />
                </button>
              </div>

              <small>
                The key is used only when creating the VIP
                invitation.
              </small>
            </div> */}


            {/* <div className="dignitary-admin-divider">
              <span />
              <b>
                VIP DETAILS
              </b>
              <span />
            </div> */}


            {/* <div className="dignitary-admin-field">
              <label htmlFor="dignitary-full-name">
                Full Name
              </label>

              <input
                id="dignitary-full-name"
                name="fullName"
                type="text"
                value={form.fullName}
                onChange={
                  handleChange
                }
                placeholder="e.g. Esteemed Pastor Jane Doe"
                required
              />
            </div> */}


            <div className="dignitary-admin-grid">
              {/* <div className="dignitary-admin-field">
                <label htmlFor="dignitary-title">
                  Title
                </label>

                <input
                  id="dignitary-title"
                  name="title"
                  type="text"
                  value={form.title}
                  onChange={
                    handleChange
                  }
                  placeholder="e.g. Esteemed Pastor"
                />
              </div> */}

              {/* <div className="dignitary-admin-field">
                <label htmlFor="dignitary-organization">
                  Ministry / Zone
                </label>

                <input
                  id="dignitary-organization"
                  name="organization"
                  type="text"
                  value={
                    form.organization
                  }
                  onChange={
                    handleChange
                  }
                  placeholder="e.g. Loveworld"
                />
              </div> */}
            </div>


            <div className="dignitary-admin-grid">
              {/* <div className="dignitary-admin-field">
                <label htmlFor="dignitary-email">
                  Email
                </label>

                <input
                  id="dignitary-email"
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={
                    handleChange
                  }
                  placeholder="Optional"
                  autoComplete="email"
                />
              </div> */}

              {/* <div className="dignitary-admin-field">
                <label htmlFor="dignitary-phone">
                  Phone
                </label>

                <input
                  id="dignitary-phone"
                  name="phone"
                  type="tel"
                  value={form.phone}
                  onChange={
                    handleChange
                  }
                  placeholder="Optional"
                  autoComplete="tel"
                />
              </div> */}
            </div>

{/* 
            <motion.button
              type="submit"
              className="dignitary-admin-submit"
              disabled={loading}
              whileHover={
                !loading
                  ? {
                      scale: 1.01,
                    }
                  : {}
              }
              whileTap={
                !loading
                  ? {
                      scale: 0.99,
                    }
                  : {}
              }
            >
              {loading
                ? 'Creating Invitation…'
                : 'Create Private Invitation'}
            </motion.button> */}
          </form>
        )}
      </motion.main>
    </div>
  );
}
